import { tv } from "@/utils/tv.config";

const radioClasses = tv({
  base: "",
  slots: {
    label: [
      "flex",
      "items-center",
      "gap-2",
      "cursor-pointer",
      "bg-white",
      "w-full",
    ],
    root: [
      "flex",
      "size-5",
      "items-center",
      "justify-center",
      "rounded-full",
      "outline-none",
      "focus-visible:outline",
      "focus-visible:outline-2",
      "focus-visible:outline-offset-2",
      "focus-visible:outline-blue-800",
      "data-[checked]:bg-primary-main",
      "data-[unchecked]:border",
      "data-[unchecked]:border-gray-300",
      "peer",
    ],
    indicator: [
      "flex",
      "before:size-2",
      "before:rounded-full",
      "before:bg-gray-50",
      "text-gray-700",
      "data-[checked]:text-white",
    ],
    rightIcon: ["hidden", "text-success-light", "peer-data-[checked]:block"],
  },
  variants: {
    variant: {
      default: {},
      options: {
        label: [
          "border",
          "p-3",
          "gap-x-4",
          "rounded-lg",
          "justify-between",
          "hover:bg-slate-50",
          "has-[:checked]:bg-gray-100",
        ],
        root: ["size-8", "rounded-md", "bg-gray-200"],
        indicator: ["before:hidden"],
      },
      card: {
        label: [
          "p-3",
          "gap-x-4",
          "rounded-lg",
          "border",
          "border-gray-300",
          "hover:bg-slate-50",
          "has-[:checked]:bg-gray-100",
          "has-[:checked]:border-primary-main",
        ],
      },
    },
  },
});

export const {
  label: radioLabelClasses,
  root: radioRootClasses,
  indicator: radioIndicatorClasses,
  rightIcon: radioRightIconClasses,
} = radioClasses();
